export default __webpack_public_path__ + "static/media/marriage.0537fae3.svg";